export const mapRoleToString = (isOwner, isManager) => {
  if (isOwner) return 'Owner';
  if (isManager) return 'Manager';
  return 'Artist';
};

export const mapInitialValues = (initialValues) => {
  const mappedInitialValues = {
    ...initialValues,
    uid: initialValues?.uid || undefined,
    region_uid: initialValues?.region?.uid || '',
    name: initialValues?.name || '',
    lastName: initialValues?.lastName || '',
    email: initialValues?.email || '',
    about: initialValues?.about || '',
    instagram_id: initialValues?.instagram_id || '',
    twitter_id: initialValues?.twitter_id || '',
    tiktok_id: initialValues?.tiktok_id || '',
    facebook_id: initialValues?.facebook_id || '',
    pinterest_id: initialValues?.pinterest_id || '',
  };

  return mappedInitialValues;
};

export const getLocationUidById = (locations, ids) =>
  ids.map((id) => locations.find((location) => location.id === Number(id)));

export const getLocationsByOwner = (locations, ownerId) =>
  locations.filter(({ owners }) => owners.includes(ownerId)).map((location) => location.id);
